import './FieldComponent.css';

import React from 'react';
import { generateClassName } from './helpers';

const FieldComponent = ({ label = null, component = null, className = null, labelAlign = 'center', componentAlign = 'center' }) => {
    return (
        <div className={generateClassName('field-component', '', className)}>
            {label && (
                <div className={`${generateClassName('field-component', '-label', className)} label-align-${labelAlign}`}>
                    {label}
                </div>
            )}
            {component && (
                <div className={`${generateClassName('field-component', '-component', className)} component-align-${componentAlign}`}>
                    {component}
                </div>
            )}
        </div>
    );
};

export default FieldComponent;